module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"drone.warranty.remain":"เวลารับประกันเหลือ {day} วัน","drone.warranty.end":"หมดอายุการรับประกันแล้ว"}}')
  delete Component.options._Ctor
}
